import {
  Goal,
  LifeArea,
  SmartList,
  Tag,
  TaskAction,
  TaskActionType,
} from '@griply/types';

export type GetTaskActionTargetOptions = {
  goals?: Goal[];
  lifeAreas?: LifeArea[];
  tags?: Tag[];
  smartLists?: SmartList[];
};

export type TaskActionTarget =
  | { type: TaskActionType.GoalTimeslot; goal: Goal }
  | { type: TaskActionType.LifeAreaTimeslot; lifeArea: LifeArea }
  | { type: TaskActionType.TagTimeslot; tag: Tag }
  | { type: TaskActionType.SmartListTimeslot; smartList: SmartList };

// Callers pass only the collections they subscribe to — an absent collection simply never resolves its type.
export const getTaskActionTarget = (
  action: TaskAction | null | undefined,
  {
    goals = [],
    lifeAreas = [],
    tags = [],
    smartLists = [],
  }: GetTaskActionTargetOptions,
): TaskActionTarget | null => {
  const targetId = action?.meta.id;
  if (!action || !targetId) {
    return null;
  }
  if (action.type === TaskActionType.GoalTimeslot) {
    const goal = goals.find(({ id }) => id === targetId);
    return goal ? { type: action.type, goal } : null;
  }
  if (action.type === TaskActionType.LifeAreaTimeslot) {
    const lifeArea = lifeAreas.find(({ id }) => id === targetId);
    return lifeArea ? { type: action.type, lifeArea } : null;
  }
  if (action.type === TaskActionType.TagTimeslot) {
    const tag = tags.find(({ id }) => id === targetId);
    return tag ? { type: action.type, tag } : null;
  }
  const smartList = smartLists.find(({ id }) => id === targetId);
  return smartList ? { type: action.type, smartList } : null;
};
